import { IDealertrackDealerDecisionData } from '../../Data/IDealertrackDealerDecisionData';
import { IDealerDecisionData } from './IDealerDecisionData';
import {ApplicationDispatch, SET_SERVER_MESSAGE} from "../../store/application/types";
import {postData} from "../../Data/fetch";
import {queryCache} from "react-query";

export interface IDealerServiceAppHistoryItems { 
    currentDecisionId: string | null,
    applicationsReceived: IApplicationsReceived[],
    acknowledgementsReceived: IAcknowledgementsReceived[],
    commentsReceived: CommentsReceived[],
    decisionsSent: IDecisionsSent[],
    commentsSent: ICommentsSent[],
    documentsReceivedAcknowledgementSent: DocumentsReceivedAcknowledgementSent[] 
}

export interface IOrderableType {
    createdDate: Date;
    typeId: string;
    title: string;
    rawXml: string;
}

export interface IApplicationsReceived extends IOrderableType, IDealertrackDealerDecisionData {
    
}

export interface IAcknowledgementsReceived extends IOrderableType {
    type: string;
    dealerTrackLenderId: string;
    dealerTrackDealerId: string;
    dealerTrackApplicationId: string;
    lenderDealerId: string;
    lenderApplicationId: string;
    errorDescription: string;
}

export interface DocumentsReceivedAcknowledgementSent extends IOrderableType {
    type: string;
    dealerTrackLenderId: string;
    dealerTrackDealerId: string;
    dealerTrackApplicationId: string;
    lenderDealerId: string;
    lenderApplicationId: string;
    errorDescription: string;
}

export interface CommentsReceived extends IOrderableType, IDealertrackDealerDecisionData {
    universalApplicationId: string;
    lenderApplicationId: string;
    comments: CommentContainer;
    dealerTrackLenderId: string;
    dealerTrackDealerId: string;
    lenderDealerId: string;
    creditType: string;
    applicationType: string;
    productType: string;
}

export interface CommentContainer {
    comment: NumberedTextElementWithValue[],
    type: string
}

export interface NumberedTextElementWithValue {
    lineNumber: number;
    value: string;
}

export interface IDecisionsSent extends IOrderableType, IDealerDecisionData {
    id: string;
}

export interface ICommentsSent extends IOrderableType, IDealertrackDealerDecisionData {
    comments: ICommentSent[];
}

export interface ICommentSent {
    commentsText: string;
    type: string;
}

export const viewCommentsReceivedForApplication = async (applicationId: string, dispatch: ApplicationDispatch) => {
    try {
        const url = `api/dealerTrack/viewCommentsReceivedForApplication/${applicationId}`;
        const response = await postData(url, {});
        await queryCache.refetchQueries('TextMessages');
        return response;
    } catch (err) {
        dispatch({
            type: SET_SERVER_MESSAGE,
            payload: { isError: true, message: err as string }
        });
    }
}